import type { FitBoundsOptions, LatLngBounds, Map } from 'leaflet';

/** Leaflet isValid() can be true while lat/lng are NaN on malformed GeoJSON bounds. */
export function isUsableLatLngBounds(bounds: LatLngBounds | null | undefined): boolean {
  if (!bounds || typeof bounds.isValid !== 'function' || !bounds.isValid()) return false;
  try {
    const sw = bounds.getSouthWest();
    const ne = bounds.getNorthEast();
    return [sw.lat, sw.lng, ne.lat, ne.lng].every((v) => Number.isFinite(v));
  } catch {
    return false;
  }
}

function mapContainerHasSize(map: Map): boolean {
  const container = map.getContainer?.();
  if (!container) return false;
  return container.offsetWidth >= 2 && container.offsetHeight >= 2;
}

/** fitBounds only when bounds and map container are valid (avoids Invalid LatLng NaN errors). */
export function safeFitBounds(map: Map, bounds: LatLngBounds, options?: FitBoundsOptions): void {
  if (!isUsableLatLngBounds(bounds)) return;

  const run = () => {
    if (!isUsableLatLngBounds(bounds) || !mapContainerHasSize(map)) return;
    try {
      map.fitBounds(bounds, options);
    } catch {
      // ignore malformed bounds / teardown races
    }
  };

  try {
    map.whenReady(() => {
      requestAnimationFrame(run);
    });
  } catch {
    // map may be tearing down
  }
}
